import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import React from 'react';
import IContentDialogService from './IContentDialogService';
import styles from './contentDialogConfirm.module.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  message: string;
  action: () => void;
}

const ContentDialogConfirm = ({ message, action }: Props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  // DI
  const dialogService = useInjection<IContentDialogService>(IocTypes.ContentDialogService);

  // handlers
  const confirmHandler = () => {
    action();
    dialogService.closeDialog();    
  }

  // render
  return (
    <div className="p-4">
      <div className="mb-3 text-center">
        {message}
      </div>
      <div className="d-flex justify-content-center">
        <button className={`btn btn-primary mr-2 ${styles.confirmBtn}`} onClick={confirmHandler}>
          {tLabels("contentDialogConfirm.yes")}
        </button>
        <button className={`btn btn-outline-secondary ${styles.confirmBtn}`} onClick={() => dialogService.closeDialog()}>
          {tLabels("contentDialogConfirm.no")}
        </button>
      </div>
    </div>
  )
}

export default ContentDialogConfirm;
